import React from 'react';
import { Page, withModel } from '@adobe/aem-react-editable-components';
import initSecContext from '../data/initSecContext.js';
import ProductPricingSection from './ProductPricingSection.js';
import StanStandalonTableSectionApp from '../standaloneTable/StandalonTableSection';
import ErrorBoundary from '../../shared/ErrorBoundary.js';
// This component is the application entry point

class App extends Page {
	constructor(props) {
		super(props);
		let tableRegex = /comp/gm;
		this.propsObj = {
			app: this.props.app,
			appWrapper: this.props.appWrapper,
			productId: this.props.productId,
			isLast: this.props.isLast,
			totalSections: this.props.totalSections,
			order: this.props.order,
			hasCT: this.hasComponentType(tableRegex).hasComp,
			ctID: this.props.ctID,
			cartURl: this.props.cartUrl,
			verificationNeeded: this.props.verificationNeeded,
			EcommAPI: this.props.EcommAPI,
			store: this.props.store,
			tabId: this.props.tabId,
			tabPanelId: this.props.tabPanelId,
			tabTitle: this.props.tabTitle,
		};
		this.flattenCardInfo = [];
		initSecContext.clearPropsContext();
		initSecContext.setPropsContext(this.propsObj);
		console.info('Allowed [ppsections]: v.8.8.8');
        this.ref = React.createRef();

        const callback = (entries) => {
          entries.forEach((entry) => {
            if (!this.state.appeared && entry.isIntersecting) {
              this.setState({
                appeared: true,
              });
            }
          });
        };

        this.observer = new IntersectionObserver(
          callback,
          {
            root: this.ref.current,
            threshold: 0.1,
          },
          this.ref.current
        );
	}

	hasComponentType(typeRegx) {
		let checkComp = {
			hasComp: false,
		};
		if (this.childComponents[0]) {
			let cqItems = this.childComponents[0].props.cqItemsOrder;
			if (cqItems.length) {
				cqItems.forEach((item) => {
					if (typeRegx.test(item)) {
						checkComp.hasComp = true;
						checkComp.type = item;
					}
				});
			}
		}
		return checkComp;
	}

    componentDidMount() {
      if (this.ref.current) {
        setTimeout(() => {
          this.observer.observe(this.ref.current);
        }, 1000);
      }
    }

	render() {
		// if tabs substract props and call sections directly
		let tabsRegex = /tabs/gm;
		let compResult = this.hasComponentType(tabsRegex);

		if (compResult.hasComp) {
			let _childComponents = this.childComponents;

			/*** Check if has table */
			let compTableProps = null;

			if (this.props.isLast) {
				let compTabRgex = /product_pricing_comp/gm;
				let checkCompTable = this.hasComponentType(compTabRgex);
				if (checkCompTable.hasComp) {
					compTableProps = _childComponents[0]['props']['cqItems']['product_pricing_comp'];
					if (compTableProps[':type'].indexOf('product-pricing-comparison-table') === -1) {
						compTableProps = null;
					}
				}
			}

			let compType = compResult.type;
			let ppSectionsOrder = _childComponents[0].props.cqItems[compType][':itemsOrder'];
			let ppSectionsItems = _childComponents[0].props.cqItems[compType][':items'];

			// we are adding this to account for the cases
			// when authors add a container inside the tab systems
			// it adds an extra layer to the childComponents object.
			if (!this.flattenCardInfo.length) {
				ppSectionsOrder.forEach((sec) => {
					let ppSecItm = ppSectionsItems[sec];
					if (ppSecItm && ':items' in ppSecItm) {
						let orderArr = ppSecItm[':itemsOrder'];
						let items = ppSecItm[':items'];
						orderArr.forEach((obj) => {
							if (':type' in items[obj] && items[obj][':type'].indexOf('product-pricing-section') > -1) {
								this.flattenCardInfo.push(items[obj]);
							}
						});
					}
				});
			}

			let productKey = ppSectionsOrder[this.props.order];
			let product = ppSectionsItems[productKey];
			if ((product && ':items' in product) || !product) {
				product = this.flattenCardInfo[this.props.order];
			}
			this.propsObj.currSec = productKey;
			initSecContext.setPropsContext(this.propsObj);

            // for buy pages with Core Tabs and a Product Pricing Comparison Table
            if(this.childComponents[0]['props']['cqItems']['product_pricing_comp']) {
              return (
                <React.Fragment>
					<ErrorBoundary>
						<ProductPricingSection productInfo={product} categoryId={this.props.productId} hasProductPricingCompTable={true} />
						{compTableProps !== null && <StanStandalonTableSectionApp tableProps={compTableProps} />}
					</ErrorBoundary>
				</React.Fragment>
              )
            }

            // for buy pages with Core Tabs and a no Product Pricing Comparison Table
			return (
				<React.Fragment>
					<ErrorBoundary>
                      <div ref={this.ref}>
                        {this.state.appeared ? (
                          <>
                            <ProductPricingSection
                              productInfo={product}
                              categoryId={this.props.productId}
                            />
                            {compTableProps !== null && (
                              <StanStandalonTableSectionApp tableProps={compTableProps} />
                            )}
                          </>
                        ) : null}
                      </div>
                    </ErrorBoundary>
				</React.Fragment>
			);
		}
		// if no tabs proceed with normal aem/react syntax
		// step one from the cqItemsOrder arr remove the not product section elms
		// then using the this.props.order pull the correct cqItem
		// add the cqitem as ide to the propsObj
		// setPropsContext with propsObj
		let cqItemsOrder = this.childComponents[0].props.cqItemsOrder;
		let cqItems = this.childComponents[0].props.cqItems;
		let compSections = [];
		this.childComponents[0].props.cqItemsOrder.forEach((sec) => {
			let ppSecItm = cqItems[sec];
			if (':type' in ppSecItm && ppSecItm[':type'].indexOf('product-pricing-section') > -1) {
				compSections.push(sec);
			}
		});
		let currSec = compSections[this.props.order];
		this.propsObj.currSec = currSec;
		initSecContext.setPropsContext(this.propsObj);

        // for buy pages with no Core Tabs and a Product Pricing Comparison Table
        if(this.childComponents[0]['props']['cqItems']['product_pricing_comp']) {
          return (
			<div className="App" test="test">
				<header className="App-header"></header>
				{this.childComponents}
				{this.childPages}
			</div>
		);
        }

        // for buy pages with no Core Tabs and a no Product Pricing Comparison Table
		return (
          <div className="App" test="test">
          <header className="App-header"></header>
          <div ref={this.ref}>
            {this.state.appeared ? (
              <>
                {this.childComponents}
                {this.childPages}
              </>
            ) : null}
          </div>
        </div>
		);
	}
}

export default withModel(App);
